import React, { useEffect, useState } from "react";
import Tooltip from "@mui/material/Tooltip";
import axios from "axios";
import {
  Pagination,
  Button,
  Typography,
  Stack,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Box,
  Drawer,
  ButtonGroup,
  DialogActions,
  TableSortLabel,
} from "@mui/material";
import {
  BaseUrl,
  emailservice,
  newBaseUrlLang,
} from "../../Container/BaseUrl/BaseUrl";
import Nodata from "../../Assets/images/svg/Data-unavailable.svg";
import facebook from "../../Assets/images/other/facebook.png";
import whatsapp from "../../Assets/images/other/whatsapp.png";
import webchat from "../../Assets/images/other/chat.png";
import twitter from "../../Assets/images/other/twitter.png";
import email from "../../Assets/images/other/email.png";
import voice from "../../Assets/images/other/phone-call.png";
import { useNavigate } from "react-router-dom";
import {
  setsidebarVal,
  GetAllUsers,
  setValue,
  getAvailableAgentList,
  setExternalChatData,
} from "../../Redux/Actions/actions";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { Eye, FunnelSimple, GitPullRequest } from "@phosphor-icons/react";
import EmailBody from "../../Components/chat-components/Chat-component/EmailBodyComponent/EmailBody";
import { toaststyle } from "../../Utils/toaststyle";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { Hourglass } from "react-loader-spinner";

import {
  StyledPaper,
  StyledTable,
  StyledTableBody,
  StyledTableCell,
  StyledTableCell2,
  StyledTableContainer,
  StyledTableHead,
  StyledTableRow,
  Search,
  SearchIconWrapper,
  StyledInputBase,
} from "../../CustomComponent/TableCompoent";
import { AiOutlineClose } from "react-icons/ai";

const headersData = [
  "Customer Name",
  "Phone Number",
  "Email",
  "Channel",
  "Status",
  "Subject",
  "Direction",
  "Skillset",
  "Language",
  "Action",
];

const mapStateToProps = (state) => {
  return {
    pullcontact: state.data.pullcontact,
    DropDownAgentList: state.contactListData.DropDownAgentList,
  };
};

const MultimediaSearch = (props) => {
  let agentRole = JSON.parse(localStorage.getItem("tokenAgent"));
  const navigate = useNavigate();
  const [chatmodal, setChatmodal] = useState(false);
  const [sessionvalueforemail, setSessionvalforemail] = useState([]);
  const [basedonchannel, setBasedonchannel] = useState("");
  const [skilldropdown, setSkilldropdown] = useState([]);

  const basedOnRole = JSON.parse(localStorage.getItem("tokenAgent"));
  var someDate = new Date();
  var date = someDate.setDate(someDate.getDate());
  var defaultValue = new Date(date).toISOString().split("T")[0];

  const isToDateValid = () => {
    return new Date(todate) >= new Date(fromdate);
  };

  const [showfilter, setshowfilter] = useState(false);
  const [agent, seAagent] = useState();
  const [name, setName] = useState();
  const [emails, setEmail] = useState();
  const [fromdate, setFromdate] = useState(defaultValue);
  const [channel, setChannel] = useState();
  const [skillSet, setSkillset] = useState();
  const [status, setStatus] = useState();
  const [searchbysubject, setsearchBySubject] = useState();
  const [searchbybody, setsearchByBody] = useState();
  const [Direction, setDirection] = useState("");
  const [mediaSearchDatas, setMediaSearchDatas] = useState([]);
  const [todate, setTodate] = useState(defaultValue);
  const [toemail, setToEmail] = useState("");

  const [pagination, setPagination] = useState(0);
  const [page, setPage] = useState(1);
  const [loadingMultimedia, setloadingMultimedia] = useState(false);
  const [searchedValues, setSearchedValues] = useState({
    customer: "",
    phone: "",
    email: "",
    channel: "",
    status: "",
    direction: "",
    skillset: "",
    language: "",
  });

  const multiMediaSearch = () => {
    setloadingMultimedia(true);
    const requestData = {
      customerName: name ? name : "",
      email: emails ? emails : "",
      toemail: toemail ? toemail : "",
      fromDate: fromdate ? fromdate : defaultValue,
      toDate: todate ? todate : defaultValue,
      category: skillSet ? skillSet : "",
      limit: 10,
      offset: page == 1 ? 0 : (page - 1) * 10,
      subject: searchbysubject ? searchbysubject : "",
      email_body: searchbybody ? searchbybody : "",
      agent: agent,
      channel: channel,
      status: status,
      direction: Direction ? Direction : "",
    };

    const headers = {
      "Content-Type": "application/json",
      Tenantid: localStorage.getItem("TenantId"),
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    };

    axios
      .post(BaseUrl + "/reports/multiMediaSearch", requestData, { headers })
      .then((response) => {
        setloadingMultimedia(true);
        console.log("multiMediaSearch", response);
        if (response.data.status == true) {
          setMediaSearchDatas(response.data.Data);
          setPagination(response.data.count);
          setloadingMultimedia(false);
        } else {
          setMediaSearchDatas([]);
          setloadingMultimedia(false);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setloadingMultimedia(false);
      });
  };

  const multiMediaSearch2 = () => {
    setloadingMultimedia(true);
    const requestData = {
      customerName: name ? name : "",
      email: emails ? emails : "",
      toemail: toemail ? toemail : "",
      fromDate: fromdate ? fromdate : defaultValue,
      toDate: todate ? todate : defaultValue,
      category: skillSet ? skillSet : "",
      limit: 10,
      offset: 0,
      subject: searchbysubject ? searchbysubject : "",
      email_body: searchbybody ? searchbybody : "",
      agent: agentRole.role == "Supervisor" ? agent : "",
      channel: channel,
      status: status,
      direction: Direction ? Direction : "",
    };

    const headers = {
      "Content-Type": "application/json",
      Tenantid: localStorage.getItem("TenantId"),
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    };

    axios
      .post(BaseUrl + "/reports/multiMediaSearch", requestData, { headers })
      .then((response) => {
        console.log("multiMediaSearch2", response);
        if (response.data.status) {
          setMediaSearchDatas(response.data.Data);
          setPagination(response.data.count);
          setTimeout(() => {
            setloadingMultimedia(false);
          }, 1000);
        } else {
          setMediaSearchDatas([]);
          setPagination(0);
          setTimeout(() => {
            setloadingMultimedia(false);
          }, 1000);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setloadingMultimedia(false);
      });
  };

  const PullContactApi = async (item) => {
    const tokenAgentValue = JSON.parse(localStorage.getItem("tokenAgent"));
    const requestData = {
      chat_session_id: item.chat_session_id,
      agent_id: tokenAgentValue.agent_id,
      user_id: tokenAgentValue.user_id,
    };

    const headers = {
      "Content-Type": "application/json",
      Tenantid: localStorage.getItem("TenantId"),
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    };

    await axios
      .post(BaseUrl + "/email/emailpullcontact", requestData, { headers })
      .then((res) => {
        if (res.data.status) {
          props.setsidebarVal("Chat");
          toast.success("Email Pull Successfully", toaststyle);
          navigate("/main/Chat");
          props.setExternalChatData(res.data.data);
          props.GetAllUsers();
          props.setValue(0);
        } else {
          toast.error(res.data.message, toaststyle);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const handlechatClose = () => setChatmodal(false);
  useEffect(() => {
    multiMediaSearch();
  }, [page]);

  const handleChange = (event, value) => {
    setPage(value);
  };
  const skillsetDropdown = () => {
    let data = {
      enabled: true,
    };
    axios
      .post(newBaseUrlLang + "usermodule/clientMaster/skills/list", data, {
        headers: {
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then((res) => {
        if (res.data.status == "OK") {
          setSkilldropdown(res.data.dataList);
        } else {
          setSkilldropdown([]);
        }
      })
      .catch((error) => {
        setSkilldropdown([]);
      });
  };
  const [expanded, setExpanded] = useState("panel1");
  const handleChange2 = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  const getSessionsDetailsForEmail = async (value) => {
    await axios
      .post(
        emailservice + "/fetchEmailSummary",
        {
          ticketID: value.ticketID,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.Data) {
          setSessionvalforemail(res.data.Data);
          setChatmodal(true);
        } else {
          setSessionvalforemail([]);
          setChatmodal(false);
        }
      })
      .catch((err) => {
        setChatmodal(false);
      });
  };
  const closeEmail = async (chat_session_id) => {
    await axios
      .post(
        BaseUrl + "/email/endEmail",
        {
          chat_session_id: chat_session_id,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          multiMediaSearch();
        }
      })
      .catch((err) => {
        setChatmodal(false);
      });
  };
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("");
  const createSortHandler = (property) => (event) => {
    const isAsc = orderBy === property && order === "desc";
    setOrder(isAsc ? "asc" : "desc");
    setOrderBy(property);
  };
  const handleSearchValues = (event, header) => {
    const eventValue = header;
    const removeSpace = eventValue.split(" ");
    const headerVal = removeSpace[0];
    setSearchedValues({ ...searchedValues, [headerVal]: event.target.value });
  };
  const filteredData = mediaSearchDatas.filter((row) => {
    return (
      (!searchedValues.customer ||
        row.unique_id.username
          .toLowerCase()
          .includes(searchedValues.customer.toLowerCase())) &&
      (!searchedValues.phone ||
        row.unique_id.phonenumber
          .toLowerCase()
          .includes(searchedValues.phone.toLowerCase())) &&
      (!searchedValues.email ||
        row.unique_id.email
          .toLowerCase()
          .includes(searchedValues.email.toLowerCase())) &&
      (!searchedValues.channel ||
        row.channel
          .toLowerCase()
          .includes(searchedValues.channel.toLowerCase())) &&
      (!searchedValues.status ||
        row.status
          .toLowerCase()
          .includes(searchedValues.status.toLowerCase())) &&
      (!searchedValues.direction ||
        row.direction
          .toLowerCase()
          .includes(searchedValues.direction.toLowerCase())) &&
      (!searchedValues.skillset ||
        row.skillset
          .toLowerCase()
          .includes(searchedValues.skillset.toLowerCase())) &&
      (!searchedValues.language ||
        row.language
          .toLowerCase()
          .includes(searchedValues.language.toLowerCase()))
    );
  });

  return (
    <>
      {/* MULTIMEDIA SEARCH start  */}
      <StyledPaper>
        <div className="card Report-card w-100 border-0">
          {/* card-header  */}
          <div
            className="card-header border-0 d-flex align-items-center justify-content-between px-2"
            sx={{ fontWeight: 600, color: "#1473e6" }}
          >
            <div
              className="fw-bold fs-16"
              style={{
                textShadow: "1px 0px 0px #c2c2c27d",
                color: "#0b3363",
              }}
            >
              Multimedia Search
            </div>
            <div>
              <ButtonGroup
                variant="contained"
                aria-label="button group"
                disableElevation
                size="small"
                sx={{
                  textTransform: "capitalize",
                }}
              >
                {/* Filter btn  */}
                <Button
                  sx={{
                    textTransform: "capitalize",
                  }}
                  onClick={() => {
                    setshowfilter(true);
                    skillsetDropdown();
                    props.getAvailableAgentList();
                  }}
                >
                  <FunnelSimple className="me-2" />
                  Filter
                </Button>
              </ButtonGroup>
            </div>
          </div>
          {/* card-body */}
          <div
            className="card-body p-1 vh-71 box-inset"
            sx={{
              justifyContent: "center",
              display: "flex",
              height: "calc(100% - 40px)",
              display: "flex",
              flexDirection: "column",
              gap: "10",
            }}
          >
            <Box>
              <StyledTableContainer sx={{ height: "26rem !important" }}>
                <StyledTable
                  stickyHeader
                  aria-label="sticky table"
                  size="small"
                >
                  <StyledTableHead>
                    <StyledTableRow>
                      {headersData.map((headers, index) => (
                        <StyledTableCell
                          style={{ minWidth: "130px" }}
                          key={index}
                        >
                          <TableSortLabel
                            direction={orderBy === headers ? order : "desc"}
                            onClick={createSortHandler(headers)}
                          >
                            {headers}
                          </TableSortLabel>
                        </StyledTableCell>
                      ))}
                    </StyledTableRow>
                  </StyledTableHead>
                  <StyledTableBody>
                    <StyledTableRow>
                      {headersData.map((headers, index) => (
                        <StyledTableCell
                          style={{ minWidth: "180px" }}
                          key={`search-${index}`}
                        >
                          {(() => {
                            switch (headers) {
                              case "Subject":
                              case "Action":
                                return "--";
                              default:
                                return (
                                  <Search>
                                    <SearchIconWrapper>
                                      <FilterAltIcon
                                        fontSize="small"
                                        sx={{ fontSize: "15px" }}
                                      />
                                    </SearchIconWrapper>
                                    <StyledInputBase
                                      sx={{ fontSize: "12px" }}
                                      placeholder={`Search ${headers}...`}
                                      inputProps={{ "aria-label": "search" }}
                                      value={
                                        searchedValues[headers.toLowerCase()]
                                      }
                                      onChange={(event) =>
                                        handleSearchValues(
                                          event,
                                          headers.toLowerCase()
                                        )
                                      }
                                    />
                                  </Search>
                                );
                            }
                          })()}
                        </StyledTableCell>
                      ))}
                    </StyledTableRow>
                    {loadingMultimedia ? (
                      <Stack
                        sx={{ position: "absolute", top: "50%", left: "50%" }}
                      >
                        <Hourglass
                          visible={true}
                          height="30"
                          width="30"
                          ariaLabel="hourglass-loading"
                          wrapperStyle={{}}
                          wrapperClass=""
                          colors={["#2268a0", "#72a1ed"]}
                        />
                      </Stack>
                    ) : filteredData.length > 0 ? (
                      filteredData
                        .sort((a, b) => {
                          {
                            switch (orderBy) {
                              case "Customer Name":
                              case "Email":
                                return order === "asc"
                                  ? a.unique_id.username.localeCompare(
                                      b.unique_id.username
                                    )
                                  : b.unique_id.username.localeCompare(
                                      a.unique_id.username
                                    );
                              case "Phone Number":
                                return order === "asc"
                                  ? a.unique_id.phonenumber.localeCompare(
                                      b.unique_id.phonenumber
                                    )
                                  : b.unique_id.phonenumber.localeCompare(
                                      a.unique_id.phonenumber
                                    );
                              case "Channel":
                                return order === "asc"
                                  ? a.channel.localeCompare(b.channel)
                                  : b.channel.localeCompare(a.channel);
                              case "Status":
                                return order === "asc"
                                  ? a.status.localeCompare(b.status)
                                  : b.status.localeCompare(a.status);
                              case "Direction":
                                return order === "asc"
                                  ? a.direction.localeCompare(b.direction)
                                  : b.direction.localeCompare(a.direction);
                              case "Skillset":
                                return order === "asc"
                                  ? a.skillset.localeCompare(b.skillset)
                                  : b.skillset.localeCompare(a.skillset);
                              case "Language":
                                return order === "asc"
                                  ? a.language.localeCompare(b.language)
                                  : b.language.localeCompare(a.language);
                              default:
                                break;
                            }
                          }
                        })
                        .map((rowData, rowIndex) => (
                          <StyledTableRow hover key={rowIndex}>
                            <StyledTableCell2>
                              {rowData.unique_id
                                ? rowData.unique_id.username
                                : "--"}
                            </StyledTableCell2>

                            <StyledTableCell2>
                              {rowData.unique_id
                                ? rowData.unique_id.phonenumber
                                : "--"}
                            </StyledTableCell2>

                            <StyledTableCell2>
                              {rowData.unique_id
                                ? rowData.unique_id.email
                                : "--"}
                            </StyledTableCell2>

                            <StyledTableCell2>
                              {rowData.channel == "webchat" ? (
                                <img
                                  className="icons-size"
                                  src={webchat}
                                  alt="webchat"
                                />
                              ) : rowData.channel == "from_whatsapp" ? (
                                <img
                                  className="icons-size"
                                  src={whatsapp}
                                  alt="webchat"
                                />
                              ) : rowData.channel == "from_twitter" ? (
                                <img
                                  className="icons-size"
                                  src={twitter}
                                  alt="webchat"
                                />
                              ) : rowData.channel == "voice" ? (
                                <img
                                  className="icons-size"
                                  src={voice}
                                  alt="webchat"
                                />
                              ) : rowData.channel == "from_facebook" ? (
                                (
                                  <img
                                    className="icons-size"
                                    src={facebook}
                                    alt="webchat"
                                  />
                                ) || rowData.channel == "from_teams"
                              ) : (
                                <img
                                  className="icons-size"
                                  src={email}
                                  alt="webchat"
                                />
                              )}
                            </StyledTableCell2>

                            <StyledTableCell2>
                              {rowData.status == "chatEnded"
                                ? "Completed"
                                : rowData.status == "newjoin"
                                  ? "Presented"
                                  : rowData.status == "Accept"
                                    ? "Active"
                                    : rowData.status}
                            </StyledTableCell2>

                            <StyledTableCell2>
                              {rowData.email_subject
                                ? rowData.email_subject
                                : "NA"}
                            </StyledTableCell2>
                            <StyledTableCell2>
                              {rowData.direction}
                            </StyledTableCell2>

                            <StyledTableCell2>
                              {rowData.skillset ? rowData.skillset : "NA"}
                            </StyledTableCell2>

                            <StyledTableCell2>
                              {rowData.language}
                            </StyledTableCell2>

                            <StyledTableCell2>
                              <Stack direction="row" spacing={0.5}>
                                {rowData.channel == "email" &&
                                rowData.status !== "Accept" &&
                                rowData.status == "newjoin" &&
                                rowData.agent == null ? (
                                  <>
                                    <Tooltip
                                      title={"Pull"}
                                      arrow
                                      placement="top"
                                    >
                                      <button
                                        type="button"
                                        className="btn btn-primary"
                                        id="contact-mail"
                                        onClick={() => {
                                          PullContactApi(rowData);
                                        }}
                                      >
                                        <GitPullRequest size={17} />
                                      </button>
                                    </Tooltip>

                                    <Tooltip
                                      title="Preview"
                                      arrow
                                      placement="top"
                                    >
                                      <button
                                        type="button"
                                        className="btn btn-primary"
                                        id="contact-mail"
                                        onClick={() => {
                                          getSessionsDetailsForEmail(rowData);
                                        }}
                                      >
                                        <Eye size={17} />
                                      </button>
                                    </Tooltip>

                                    <Tooltip
                                      title="Close"
                                      arrow
                                      placement="top"
                                    >
                                      <button
                                        type="button"
                                        className="btn btn-primary"
                                        id="contact-mail"
                                        onClick={() => {
                                          closeEmail(rowData.chat_session_id);
                                        }}
                                      >
                                        <AiOutlineClose size={17} />
                                      </button>
                                    </Tooltip>
                                  </>
                                ) : rowData.channel == "email" &&
                                  ((rowData.status === "newjoin" &&
                                    rowData.agent == null) ||
                                    rowData.status == "chatEnded") ? (
                                  <>
                                    <Tooltip
                                      title={"Pull"}
                                      arrow
                                      placement="top"
                                    >
                                      <button
                                        type="button"
                                        className="btn btn-primary"
                                        id="contact-mail"
                                        onClick={() => {
                                          PullContactApi(rowData);
                                        }}
                                      >
                                        <GitPullRequest size={17} />
                                      </button>
                                    </Tooltip>

                                    <Tooltip
                                      title="Preview"
                                      arrow
                                      placement="top"
                                    >
                                      <button
                                        type="button"
                                        className="btn btn-primary"
                                        id="contact-mail"
                                        onClick={() => {
                                          getSessionsDetailsForEmail(rowData);
                                        }}
                                      >
                                        <Eye size={17} />
                                      </button>
                                    </Tooltip>
                                  </>
                                ) : rowData.channel == "email" ? (
                                  <>
                                    <Tooltip
                                      title="Preview"
                                      arrow
                                      placement="top"
                                    >
                                      <button
                                        type="button"
                                        className="btn btn-primary"
                                        id="contact-mail"
                                        onClick={() => {
                                          getSessionsDetailsForEmail(rowData);
                                        }}
                                      >
                                        <Eye size={17} />
                                      </button>
                                    </Tooltip>
                                  </>
                                ) : (
                                  "--"
                                )}
                              </Stack>
                            </StyledTableCell2>
                          </StyledTableRow>
                        ))
                    ) : (
                      // Data unavailable start
                      <Stack
                        sx={{
                          position: "absolute",
                          width: "100%",
                          height: "calc(100vh - 14rem)",
                        }}
                        justifyContent="center"
                        alignContent="center"
                      >
                        <Stack
                          className="text-muted"
                          direction="column"
                          justifyContent="center"
                          alignContent="center"
                        >
                          <span className="mx-auto">
                            <img
                              src={Nodata}
                              alt="pic"
                              style={{ width: "11rem", userSelect: "none" }}
                            />
                          </span>
                          <span className="mx-auto">
                            <h6
                              className="text-muted mt-3"
                              style={{ fontSize: "13px" }}
                            >
                              Data unavailable
                            </h6>
                          </span>
                        </Stack>
                      </Stack>
                      // Data unavailable end
                    )}
                  </StyledTableBody>
                </StyledTable>
              </StyledTableContainer>
            </Box>
          </div>
          {/* card-footer */}
          <div className="card-footer border-0">
            <Box>
              <Stack
                sx={{ width: "100%", height: "100%" }}
                direction={"row"}
                alignItems={"center"}
                justifyContent={"space-between"}
              >
                {/* Pagination content  */}
                <Typography variant="caption" sx={{ fontSize: "12px" }}>
                  Showing {Math.min((page - 1) * 10 + 1, pagination)} to{" "}
                  {Math.min(page * 10, pagination)} of {pagination} entries
                </Typography>
                {/* Pagination  */}
                <Pagination
                  count={Math.ceil(pagination / 10)}
                  page={page}
                  shape="rounded"
                  color="primary"
                  size="small"
                  style={{ float: "right" }}
                  onChange={handleChange}
                />
              </Stack>
            </Box>
          </div>
        </div>

        {/* Interaction Preview start  */}
        {chatmodal && (
          <Dialog
            open={chatmodal}
            keepMounted
            onClose={handlechatClose}
            aria-describedby="alert-dialog-slide-description"
            fullWidth
            maxWidth="md"
          >
            <DialogTitle
              variant="subtitle2"
              sx={{
                fontSize: "16px",
                fontWeight: 600,
                color: "#0b3363",
                boxShadow:
                  "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
              }}
            >
              Interaction Preview
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                <Box className="mt-3">
                  <Stack
                    spacing={2}
                    justifyContent={"center"}
                    alignItems={"center"}
                  >
                    {sessionvalueforemail.length > 0
                      ? sessionvalueforemail.map((mail, index) => {
                          return (
                            <EmailBody
                              mail={mail}
                              index={index}
                              handleChange={handleChange2}
                              expanded={expanded}
                              preview={true}
                            />
                          );
                        })
                      : ""}
                  </Stack>
                </Box>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={handlechatClose}
                variant="outlined"
                color="error"
                size="small"
                sx={{ textTransform: "capitalize !important" }}
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>
        )}
        {/* Interaction Preview end  */}
        {/* Filters Drawer Start  */}
        <Drawer
          anchor="right"
          open={showfilter}
          onClose={() => {
            setshowfilter(false);
          }}
        >
          <Box style={{ width: "20rem" }}>
            {/* Drawer head start */}
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              className="p-3 shadowDrawer"
            >
              <Typography variant="h3" gutterBottom className="drawer-title">
                Filters
              </Typography>
            </Stack>
            {/* Drawer head end */}
            {/* Drawer Content start */}
            <Stack
              className="p-3"
              style={{ height: "calc(100vh - 7rem)", overflowY: "scroll" }}
            >
              <form className="fs-13">
                <div className="custom_div">
                  <div className="mb-3 d-flex flex-column text-start">
                    <label htmlFor="Select" className="form-label">
                      Agent
                    </label>
                    <select
                      className="form-select fs-13"
                      aria-label="Default select example"
                      onChange={(e) => seAagent(e.target.value)}
                      value={agent}
                    >
                      <option value="">Select Agent</option>
                      <option value="">Select All</option>

                      {props.DropDownAgentList.length > 0
                        ? props.DropDownAgentList.map((item) => {
                            return (
                              <option value={item.id} key={item.id}>
                                {item.username}
                              </option>
                            );
                          })
                        : ""}
                    </select>
                  </div>

                  <div className="mb-3 d-flex flex-column text-start">
                    <label className="form-label">Name</label>
                    <input
                      type="text"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      className="form-control"
                    />
                  </div>

                  <div className="mb-3 d-flex flex-column text-start">
                    <label className="form-label">From Email</label>
                    <input
                      type="text"
                      onChange={(e) => setEmail(e.target.value)}
                      className="form-control"
                      value={emails}
                    />
                  </div>

                  <div className="mb-3 d-flex flex-column text-start">
                    <label className="form-label">To Email</label>
                    <input
                      type="text"
                      value={toemail}
                      onChange={(e) => setToEmail(e.target.value)}
                      className="form-control"
                    />
                  </div>
                  <div className="mb-3 d-flex flex-column text-start">
                    <label htmlFor="Select" className="form-label">
                      Direction
                    </label>
                    <select
                      className="form-select fs-13"
                      aria-label="Default select example"
                      onChange={(e) => setDirection(e.target.value)}
                      value={Direction}
                    >
                      <option value="">Select Direction</option>
                      <option value="">Select All</option>
                      <option value="Inbound">Inbound</option>
                      <option value="Outbound">Outbound</option>
                      <option value="MC_Outbound">MC_Outbound</option>
                      <option value="CM_Outbound">CM_Outbound</option>
                    </select>
                  </div>
                  <div className="mb-3 d-flex flex-column text-start">
                    <label htmlFor="fromdate" className="form-label">
                      From
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      id=""
                      aria-describedby="date"
                      value={fromdate}
                      onChange={(e) => setFromdate(e.target.value)}
                      max={defaultValue}
                    />
                  </div>
                  <div className="mb-3 d-flex flex-column text-start">
                    <label htmlFor="todate" className="form-label">
                      To
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      id=""
                      aria-describedby="date"
                      value={todate}
                      onChange={(e) => setTodate(e.target.value)}
                      max={defaultValue}
                    />
                    {!isToDateValid() && (
                      <span className="text-danger fw-bold fs-9">
                        To Date cannot be less than From Date*
                      </span>
                    )}
                  </div>
                </div>

                <div className="mb-3 d-flex flex-column text-start">
                  <label htmlFor="Select" className="form-label">
                    Channel
                  </label>
                  <select
                    className="form-select fs-13"
                    aria-label="Default select example"
                    onChange={(e) => {
                      setBasedonchannel(e.target.value);
                      setChannel(e.target.value);
                    }}
                    value={channel}
                  >
                    <option value="">Select Channel</option>
                    <option value="">Select All</option>
                    <option value="webchat">Webchat</option>
                    <option value="email">Email</option>
                    <option value="voice">Voice</option>
                    <option value="from_whatsapp">Whatsapp</option>
                  </select>
                </div>
                <div className="mb-3 d-flex flex-column text-start">
                  <label htmlFor="Select" className="form-label">
                    Skillset
                  </label>
                  <select
                    className="form-select fs-13"
                    aria-label="Default select example"
                    onChange={(e) => setSkillset(e.target.value)}
                    value={skillSet}
                  >
                    <option value="">Select Skillset</option>
                    <option value="">Select All</option>
                    {skilldropdown.length > 0
                      ? skilldropdown.map((item) => {
                          return (
                            <>
                              <option value={item.skillName}>
                                {item.skillName}
                              </option>
                            </>
                          );
                        })
                      : ""}
                  </select>
                </div>

                <div className="mb-3 d-flex flex-column text-start">
                  <label htmlFor="Select" className="form-label">
                    Status
                  </label>
                  <select
                    className="form-select fs-13"
                    aria-label="Default select example"
                    onChange={(e) => setStatus(e.target.value)}
                    value={status}
                  >
                    <option value="">Select Status</option>
                    <option value="">Select All</option>
                    <option value="Accept">Active</option>
                    <option value="chatEnded"> Completed</option>
                    <option value="newjoin"> Presented</option>
                    <option value="Queued"> Queued</option>
                    {basedonchannel == "webchat" ? (
                      <option value="CustomerDropped">CustomerDropped</option>
                    ) : (
                      ""
                    )}
                  </select>
                </div>

                {basedonchannel == "email" ? (
                  <div className="mb-3 d-flex flex-column text-start">
                    <label htmlFor="Select" className="form-label">
                      Search
                    </label>

                    <div className="mt-2 d-flex flex-column text-start">
                      <input
                        type="text"
                        onChange={(e) => {
                          setsearchBySubject(e.target.value);
                        }}
                        className="form-control fs-13"
                        placeholder="Enter Subject..."
                        value={searchbysubject}
                      />
                    </div>

                    <div className="mt-2 d-flex flex-column text-start">
                      <input
                        type="text"
                        onChange={(e) => setsearchByBody(e.target.value)}
                        className="form-control "
                        placeholder="Search By Keywords..."
                        value={searchbybody}
                      />
                    </div>
                  </div>
                ) : null}
              </form>
            </Stack>
            {/* Drawer Content end */}
            {/* Drawer footer start */}
            <Stack
              className="p-2"
              sx={{
                position: "absolute",
                bottom: "0",
                background: "#f9f9f9",
                width: "100%",
                boxShadow:
                  "rgba(14, 63, 126, 0.04) 0px 0px 0px 1px, rgba(42, 51, 69, 0.04) 0px 1px 1px -0.5px, rgba(42, 51, 70, 0.04) 0px 3px 3px -1.5px, rgba(42, 51, 70, 0.04) 0px 6px 6px -3px, rgba(14, 63, 126, 0.04) 0px 12px 12px -6px, rgba(14, 63, 126, 0.04) 0px 24px 24px -12px",
              }}
              direction="row"
              justifyContent="space-between"
              alignContent="center"
            >
              <Button
                variant="contained"
                className="me-2 w-100"
                sx={{
                  textShadow: "0 1px 0 rgba(0, 0, 0, .4)",
                  textTransform: "Capitalize",
                }}
                color="error"
                disableElevation
                onClick={() => {
                  setshowfilter(false);
                }}
              >
                Close
              </Button>
              <Button
                className="w-100"
                variant="contained"
                disableElevation
                sx={{
                  textShadow: "0 1px 0 rgba(0, 0, 0, .4)",
                  textTransform: "Capitalize",
                }}
                id="session_filter_Submit"
                onClick={() => {
                  if (isToDateValid()) {
                    multiMediaSearch2();
                    setPage(1);
                    setshowfilter(false);
                  }
                }}
              >
                Submit
              </Button>
            </Stack>
            {/* Drawer footer end */}
          </Box>
        </Drawer>
        {/* Filters Drawer End  */}
      </StyledPaper>
      {/* MULTIMEDIA SEARCH END  */}
    </>
  );
};

export default connect(mapStateToProps, {
  setsidebarVal,
  GetAllUsers,
  setValue,
  getAvailableAgentList,
  setExternalChatData,
})(MultimediaSearch);
